<h3 style="text-align: center;">{{ editedUser.name }} ({{ editedUser.uid }})</h3>

<div style="background-color: #f5f5f5; padding: 10px; margin-bottom: 15px; border-radius: 4px;">
  <p style="margin: 5px 0;"><strong>Team Laravel :</strong> {{ editedUser.team_name }}</p>
  <p style="margin: 5px 0;"><strong>Rôle par défaut :</strong> {{ editedUser.default_role_name }}</p>
  <p style="margin: 5px 0;" *ngIf="editedUser.custom_role_id">
    <strong style="color: #27ae60;">Rôle personnalisé actuel :</strong>
    <span style="color: #27ae60;">{{ editedUser.custom_role_name }}</span>
  </p>
</div>

<h4>Rôle personnalisé</h4>
<mat-form-field appearance="fill" style="width: 100%;">
  <mat-label>Rôle (laisser vide pour utiliser le rôle par défaut)</mat-label>
  <mat-select [(value)]="roleSelected">
    <mat-option [value]="null">-- Utiliser le rôle par défaut --</mat-option>
    <mat-option *ngFor="let role of roles" [value]="role.id" [disabled]="role.id === 1">
      {{ role.name }}
    </mat-option>
  </mat-select>
  <mat-hint>{{ returnDescRole() }}</mat-hint>
</mat-form-field>

<h4>Stations sélectionnées automatiquement dans la table "Musiques"</h4>
<mat-form-field appearance="fill" style="width: 100%;">
  <mat-label>Stations sélectionnées automatiquement dans la table "Musiques"</mat-label>
  <mat-select [(value)]="stationsSelected" multiple>
    <mat-option *ngFor="let station of stations" [value]="station.id">{{ station.label }}</mat-option>
  </mat-select>
  <mat-hint *ngIf="stationsFromDefault" style="color: #e67e22;">
    Valeur par défaut du rôle (aucune config personnalisée)
  </mat-hint>
  <mat-hint *ngIf="!stationsFromDefault">Vide = utiliser la configuration par défaut du rôle</mat-hint>
</mat-form-field>

<h4>Catégorie sélectionnée automatiquement dans la table "Sons"</h4>
<mat-tab-group #categorieTab mat-align-tabs="center" style="margin-bottom: 20px;">
  <mat-tab label="Sélectionner">
    <mat-form-field appearance="fill" style="width: 100%; margin-top: 20px;">
      <mat-label>Catégorie sélectionnée automatiquement dans la table "Sons"</mat-label>
      <mat-select [(value)]="categorieSelected">
        <mat-option></mat-option>
        <mat-option *ngFor="let categorie of categories" [value]="categorie.id">
          {{ categorie.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-tab>
  <mat-tab label="Ajouter">
    <div style="margin-top: 20px;">
      <mat-form-field style="width: 100%;">
        <mat-label>Catégorie Winmedia</mat-label>
        <input #catLabel value="" matInput required>
        <mat-hint align="start">
          <strong *ngIf="checkNewCategorieExists()"
              style="color: #f44336; font-size: 12px;">
            Cette catégorie existe déjà !
          </strong>
          <strong *ngIf="!checkNewCategorieExists()">
            Nom de la catégorie écrit exactement comme dans Winmedia
          </strong>
        </mat-hint>
      </mat-form-field>
    </div>
  </mat-tab>
</mat-tab-group>

<h4>Colonnes cachées dans la table "Musiques"</h4>
<mat-form-field appearance="fill" style="width: 100%;">
  <mat-label>Colonnes cachées dans la table "Musiques"</mat-label>
  <mat-select [(value)]="hiddencolumnsSelected" multiple>
    <mat-option *ngFor="let col of availableColumns" [value]="col.index">
      {{ col.index }} - {{ col.label }}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="hiddencolumnsFromDefault" style="color: #e67e22;">
    Valeur par défaut du rôle (aucune config personnalisée)
  </mat-hint>
  <mat-hint *ngIf="!hiddencolumnsFromDefault">Vide = utiliser la configuration par défaut du rôle</mat-hint>
</mat-form-field>

<div style="margin-top: 16px;">
  <mat-slide-toggle [(ngModel)]="preferNickname">
    Préférer l'utilisation du Surnom si défini
  </mat-slide-toggle>
</div>

<div style="margin-top: 16px;">
  <mat-slide-toggle [(ngModel)]="lowBitrateAllowed">
    Autoriser l'upload en bitrate réduit (128Kbps au lieu de 320/256Kbps)
  </mat-slide-toggle>
</div>

<div style="margin-top: 20px;">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button
          color="primary"
          (click)="saveSettings()"
          [disabled]="isSaveDisabled()"
          style="margin-left: 10px;">
    Enregistrer
  </button>
  <button mat-raised-button color="warn" (click)="removeSettings()" style="margin-left: 10px;">Supprimer les réglages</button>
</div>
